export default __webpack_public_path__ + "static/media/IndigenousPeoples_fr.3cfa74cd.svg";